import { FC } from 'react'

import {
  AdditionalAmenitiesStep,
  AddressMapStep,
  AddressStep,
  AmenitiesStep,
  ConditionsStep,
  ConfirmationStep,
  DescriptionStep,
  ObjectTypeStep,
  PhotosStep,
  PriceStep,
} from 'features/kyrgyzstan/create-object'
import type {
  CreateObjectDraftStepId,
  CreateObjectDraftStepScreenProps,
  ObjectTypeStepScreenProps,
} from 'features/kyrgyzstan/create-object/types'

import { CreateObjectStepId } from 'entities/kyrgyzstan/model/create-object'

export const createObjectObjectTypeStepComponent: FC<ObjectTypeStepScreenProps> =
  ObjectTypeStep

export const createObjectDraftStepComponentMap: Record<
  CreateObjectDraftStepId,
  FC<CreateObjectDraftStepScreenProps>
> = {
  [CreateObjectStepId.Photos]: PhotosStep,
  [CreateObjectStepId.Address]: AddressStep,
  [CreateObjectStepId.AddressMap]: AddressMapStep,
  [CreateObjectStepId.Amenities]: AmenitiesStep,
  [CreateObjectStepId.AdditionalAmenities]: AdditionalAmenitiesStep,
  [CreateObjectStepId.Description]: DescriptionStep,
  [CreateObjectStepId.Price]: PriceStep,
  [CreateObjectStepId.Conditions]: ConditionsStep,
  [CreateObjectStepId.Confirmation]: ConfirmationStep,
}
